import useRemoveCourierPrivilege from "api/UserResource/useRemoveCourierPrivilege";
import useUpdateUserPermissions from "api/UserResource/useUpdateUserPermissions";
import { ConfirmPopup } from "primereact/confirmpopup";
import React from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { BsExclamationDiamond } from "react-icons/bs";
import { CgChevronRight } from "react-icons/cg";
import { FiX } from "react-icons/fi";
import { Permission } from "utils/server-constants/permissions";

const ManageUserCourierPrivilege = (props) => {
	const { id, hasCourierPrivilege, permissions } = props;
	const [visible, setVisible] = React.useState(false);
	const elementId = `remove-courier-privilege-02-${id}`;

	// console.log({ elementId });

	const { mutateAsync, isLoading } = useRemoveCourierPrivilege();
	const revokePermission = async () => {
		try {
			await mutateAsync(id);
			setVisible(false);
		} catch (error) {
			// console.log(error);
		}
	};

	const { mutateAsync: syncPermissions, isLoading: isSyncingPermissions } =
		useUpdateUserPermissions(id);

	async function assignPermission() {
		await syncPermissions({
			permission_names: [...permissions, Permission.Courier],
		});
	}

	return (
		<div
			className="space-y-6"
			style={{ maxWidth: 400 }}
		>
			<div>
				<h4 className="">Manage "Courier" privileges</h4>
				<p>
					{hasCourierPrivilege
						? "This user has privileges to manage courier services."
						: "This user does not have privileges to manage courier services."}
				</p>
			</div>
			<p>
				"Courier" privilege allows a user to deliver books to customers for
				orders that are assigned to them.
			</p>

			{hasCourierPrivilege ? (
				<div className="flex items-center gap-2">
					<button
						className="text-red-500 border border-red-600 py-2 px-3 rounded-full flex items-center gap-1"
						onClick={() => setVisible(true)}
						id={elementId}
					>
						Remove privilege
						{isLoading ? (
							<AiOutlineLoading3Quarters
								size={15}
								className="animate-spin"
							/>
						) : (
							<FiX size={15} />
						)}
					</button>

					<ConfirmPopup
						target={document.getElementById(elementId)}
						visible={visible}
						onHide={() => setVisible(false)}
						className="font-sans text-sm"
						message={
							<div
								className="space-y-2"
								style={{ maxWidth: "400px" }}
							>
								<BsExclamationDiamond
									size={40}
									className="text-red-600"
								/>

								<p className="text-base font-bold">
									Do you want to remove "Courier" privilege from this user?
								</p>
								<p>
									Note that this action will result in the user losing their
									"Courier" privilege. The user will not be able to perform any
									courier related activities
								</p>
							</div>
						}
						accept={revokePermission}
					/>
				</div>
			) : (
				<div className="flex items-center gap-2">
					<button
						type="button"
						className=" py-2 px-3 rounded-full flex items-center gap-1 text-akgreenest border border-akgreener"
						onClick={assignPermission}
					>
						Assign "Courier" privilege
						{isSyncingPermissions ? (
							<AiOutlineLoading3Quarters
								size={20}
								className="animate-spin"
							/>
						) : (
							<CgChevronRight size={20} />
						)}
					</button>
				</div>
			)}
		</div>
	);
};

export default ManageUserCourierPrivilege;
